import React from 'react';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ColorPicker } from '../../config/ColorPicker';
import colorFinder from '../../utils/colorFinder';
import AttachmentIcon from '@mui/icons-material/Attachment';

import Fields from './Fields';
import { ButtonUI } from '../Interface';
import productionService from '../../service/production.service';
import useUsers from '../../context/UsersContext';

const JobMonitorCard = ({
  data,
  getProductionById,
  onDragStart,
  type,
  setRefetchResources,
  setIsAttachmentDialogOpen,
  setAttachments,
  autoCompleteData,
  onFeedbackClick,
}) => {
  const { user } = useUsers();
  const bgColor = colorFinder(data?.productionStatus?.color);

  const foundedColor = autoCompleteData?.status?.find(
    (status) => status.code === data?.jmV2ExtendedData?.prevStatus
  )?.color;

  const jvmBackgroundColor = colorFinder(foundedColor);

  const handleCheckClick = async (id) => {
    await productionService.updateStatus({
      id: id,
      productionStatusId: 'VERIFIED',
      updatedBy: user.userId,
    });
    setRefetchResources(true);
  };

  return (
    <Box
      className="min-h-[200px] mb-3 rounded-md p-4 shadow-md"
      sx={{ backgroundColor: bgColor?.jobMonitorBgColor, '&:hover': { background: bgColor?.jobMonitorHoverColor } }}
      onDragStart={(event) => onDragStart(event, data)}
      draggable
    >
      <div className="flex justify-between w-full flex-wrap">
        <div className="flex items-center gap-3 flex-wrap">
          <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{data.label}</Typography>
          <Chip
            label={data?.productionStatus?.name}
            size="small"
            sx={{ backgroundColor: bgColor?.jobMonitorChipColor }}
          />
          {type !== 'RESOURCECOLUMN' && <Typography>{data.production?.articleNumber}</Typography>}
        </div>

        <Box display="flex">
          <Box
            backgroundColor="rgba(240, 237, 45, 0.74)"
            p="0.4rem 0.6rem 0rem 0.6rem"
            mr="0.5rem"
            borderRadius="12px"
            sx={{ cursor: 'pointer' }}
            onClick={(event) => {
              event.stopPropagation();
              onFeedbackClick(data);
            }}
          >
            <Typography fontWeight="bold">Fb</Typography>
          </Box>
          <IconButton
            sx={{ mr: 1, p: 0 }}
            onClick={(event) => {
              event.stopPropagation();
              setAttachments([...(data.sourceListAttachment ?? []), ...(data.itemAttachment ?? [])]);
              setIsAttachmentDialogOpen(true);
            }}
          >
            <AttachmentIcon
              sx={{
                fontSize: '2rem',
                color: [...(data?.sourceListAttachment ?? []), ...(data?.itemAttachment ?? [])].length > 0 && '#0065F8',
              }}
            />
          </IconButton>
          <Box
            className="bg-white text-black px-2 py-1.5 rounded pt-[0.4rem] cursor-pointer"
            onClick={() => {
              getProductionById(data.productionId);
            }}
          >
            <RemoveRedEyeIcon sx={{ fontSize: '1.4rem' }} />
          </Box>
        </Box>
        {data.productionStatusId === 'COMPLETED' && (
          <>
            <ButtonUI
              text="Ellenőrzés"
              className="mt-2"
              color="blue-gray"
              type="button"
              variant="gradient"
              onClick={() => handleCheckClick(data.id)}
            ></ButtonUI>
          </>
        )}
      </div>
      <Fields data={data} bgColor={bgColor} type={type} jvmBackgroundColor={jvmBackgroundColor} />
    </Box>
  );
};

export default JobMonitorCard;
